import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ngClassObject } from '../../../types';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'p-loader',
  templateUrl: './p-loader.component.html',
  styleUrls: ['./p-loader.component.scss'],
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PLoaderComponent {
  @Input() size: 'small' | 'medium' | 'large' = 'medium';

  get classes(): ngClassObject<string> {
    return {
      'large-loader': this.size === 'large',
      'medium-loader': this.size === 'medium',
      // On laisse les styles par défaut pour le loader small
      '': this.size === 'small',
    };
  }
}
